import React from 'react';

const Avatar = ({ src, name, size = 'md', style = {} }) => {
  const getInitials = (n) => {
    if (!n) return '?';
    return n.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  };

  if (src) {
    return (
      <img
        src={src}
        alt={name || ''}
        className={`avatar avatar-${size}`}
        style={style}
        onError={e => { e.target.style.display = 'none'; }}
      />
    );
  }

  return (
    <div className={`avatar avatar-${size}`} style={style}>
      {getInitials(name)}
    </div>
  );
};

export default Avatar;
